import { useMemo } from "react";
import { Flex, Text, Progress } from "@chakra-ui/react";

import { formatNumber, numberToCurrency } from "utils";
import { useSelector } from "react-redux";

type PoolLimitDataType = {
  poolLimit: number;
  usedValue: number;
  isLoading: boolean;
};

interface StakeLimitTyype {
  poolData: PoolLimitDataType;
}

const StakeLimit = ({ poolData }: StakeLimitTyype) => {
  const usedLimitPerc = useMemo(() => {
    if (poolData.usedValue) {
      return (poolData.usedValue * 100) / poolData.poolLimit;
    }
    return 0;
  }, [poolData]);

  const { selectedERC20 } = useSelector((state: any) => state.user);

  return (
    <>
      {poolData.poolLimit ? (
        <Flex
          flexDir="column"
          gap="8px"
          py={{ base: "8px", md: "24px" }}
          alignItems="flex-start"
          width="100%"
          mt={{ base: "32px", md: "24px" }}
        >
          <Flex justifyContent="space-between" alignItems="center" width="100%">
            <Flex gap="8px">
              <Text
                color="textPrimary"
                fontWeight="500"
                fontSize="14px"
                lineHeight="24px"
              >
                Restaking limit
              </Text>
            </Flex>
            <Text
              color="textSecondary"
              fontWeight="400"
              fontSize="12px"
              lineHeight="18px"
            >
              <span>{formatNumber(poolData.usedValue, false, 2)} / </span>
              <span>
                {numberToCurrency(poolData.poolLimit.toString())}{" "}
                {selectedERC20}
              </span>
            </Text>
          </Flex>

          <Progress
            bg="backgroundCanvas"
            value={usedLimitPerc}
            size="xs"
            color="accent1"
            borderRadius="8px"
            width="100%"
            opacity="0.4"
            height="8px"
          />
        </Flex>
      ) : null}
    </>
  );
};

export default StakeLimit;
